<template>
<div id="login" v-if="!auth.id">
    <div class="container" style="margin-bottom: 50px;">
        <div class="row">
            <h1 style="text-align: center;" >Авторизация</h1>
            <br>
            <div class="alert alert-danger col-md-offset-20 col-md-80" role="alert"
                 v-if="errors" v-html="errors"></div>
            <div> <!--  -->

                <div class="form-group col-md-offset-30 col-md-60">
                    <input type="text" class="form-control"
                           placeholder="Введите email или телефон" name="email" v-model="login">
                </div>

                <div class="form-group col-md-offset-30 col-md-60">
                    <input type="password" class="form-control"
                           placeholder="Введите пароль" name="pass" v-model="password">
                </div>

                <div class="form-group col-md-offset-30 col-md-60" >
                    <button type="submit" class="btn btn-primary" @click="sendAuth">Войти</button>
                    <router-link to="/cabinet/passresset/" class="btn btn-default" style="float:right;">Забыли пароль</router-link>
                </div>

            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'login',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      errors: '',
      login: '',
      password: ''
    }
  },
  updated () {
    if (this.auth.id) window.location.href = '/cabinet/'
  },
  created () {
    if (this.auth.id) window.location.href = '/cabinet/'
  },
  mounted () {
    if (this.auth.id) window.location.href = '/cabinet/'
  },
  methods: {
    sendAuth () {
      var errors = []
      var $this = this
      if (!this.login) errors.push('Необходимо заполнить логин')
      if (!this.password) errors.push('Необходимо заполнить пароль')
      if (errors.length === 0) {
        var formData = new FormData()
        formData.append('login', this.login)
        formData.append('password', this.password)
        formData.append('uid', this.user.uid)
        axios.post('https://crm.v-avtoservice.com/list/site-auth',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(function (response) {
          console.log(response.data)
          if (response.data.title) $this.errors = response.data.text
          else window.location.href = '/cabinet/'
        })
          .catch(function () {
          })
      }
      this.errors = errors.join('<br>')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cabinet/login.vue